import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Voegtoe from '@/components/Voegtoe'
import Success from '@/components/Success'

Vue.use(Router)

export default new Router({
  routes: [
    {
    	path: '/',
	    name: 'Home',
	    component: Home,
    },
	{
    	path: '/voegtoe',
	    name: 'Voegtoe',
	    component: Voegtoe,
    },
	{
    	path: '/success',
	    name: 'Success',
	    component: Success,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js